import express, { Router } from 'express';

import * as DashboardController from '@/modules/dashboard/dashboard.controller';
import * as dashboardValidation from '@/modules/dashboard/dashboard.validation';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { validateMiddleware } from '@/shared/utils/middlewares/index';

const router: Router = express.Router();

router.route('/broker').get(
  userAuthAndCheckPermissions(),
  // validateMiddleware(CustomFieldsValidation.getCustomFields),
  DashboardController.getBrokerDashboard,
);

router.route('/broker/team-report').get(
  userAuthAndCheckPermissions(),
  validateMiddleware(dashboardValidation.getTeamActivitySummaryReport),
  DashboardController.getTeamActivitySummaryReport,
);

router.route('/builder').get(
  userAuthAndCheckPermissions(),
  // validateMiddleware(CustomFieldsValidation.getCustomFieldsById),
  DashboardController.getBuilderDashboard,
);

router.route('/superAdmin').get(
  userAuthAndCheckPermissions(),
  // validateMiddleware(CustomFieldsValidation.getCustomFieldsById),
  DashboardController.getSuperAdminDashboard,
);

export default router;
